import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, switchMap, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { inject } from '@angular/core';

export const errorHandlingInterceptor: HttpInterceptorFn = (req, next) => {
  // const authToken = inject(AuthService).getAuthorizationToken();

  return next(req).pipe(
    catchError((err: any) => {
      if (err instanceof HttpErrorResponse) {
        // Handle HTTP errors
        if (err.status === 401) {
          return inject(AuthService).refreshToken().pipe(
            switchMap((tokenReceived) => {
              const authToken = inject(AuthService).getAuthorizationToken();
              if (authToken) {
                // Ensure authToken is not undefined before accessing its properties
                req = req.clone({
                  headers: req.headers.set('authorization', authToken.authorization ?? '') // Use empty string as default if auth_token is undefined
                });
              }
              return next(req);
            })
          );
        }
         else {
          // Handle other HTTP error codes
          console.error('HTTP error:', err);
        }
      } else {
        // Handle non-HTTP errors
        console.error('An error occurred:', err);
      }

      // Re-throw the error to propagate it further
      return throwError(() => err); 
    })
  );
};
